import { createContext, useContext } from 'react';
import type { ProposedApi } from './api';

/**
 * True only when the Wave-4 prototype surfaces may render. Prototypes (node notes,
 * branch indicators) are backed by an in-memory mock, so
 * they are strictly limited to mock-mode builds (`VITE_USE_MOCK=1`, ADR-0013).
 * A real-API build never fabricates or "persists" prototype data.
 */
export const ProposedEnabledContext = createContext(false);

export const ProposedApiContext = createContext<ProposedApi | null>(null);

export function useProposedApi(): ProposedApi {
  const api = useContext(ProposedApiContext);
  if (api === null) {
    throw new Error('useProposedApi must be used within a <ProposedApiProvider>.');
  }
  return api;
}

export function useProposedEnabled(): boolean {
  return useContext(ProposedEnabledContext);
}
